import React, { useState, useRef, useEffect } from 'react';
import { FiLink } from 'react-icons/fi';
import PillButton from './PillButton';

export default ({ url, style = {} }) => {
  const [isCopied, setIsCopied] = useState(false)
  const timeoutRef = useRef()

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current)
  }, [])

  const onCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(url);
    setIsCopied(true);
    timeoutRef.current = setTimeout(() => setIsCopied(false), 2000);
  }

  return (
    <PillButton $primary={true} onClick={onCopy} style={style}>
      <FiLink />
      {isCopied ? 'Copied!' : 'Copy URL'}
    </PillButton>
  )
}
